<template>
  <h1 v-if="user" class="prenom-profil">
    <template v-if="!user.company">
      {{ user.first_name }}
      <span class="personal-info">
        <div v-if="addressTxt != ''">{{ addressTxt }}</div>
      </span>
    </template>
    <template v-else>
      {{ user.company.business_name ? user.company.business_name : user.first_name }}
    </template>
  </h1>
</template>

<script>
import { eventBus } from '../../main'
import { optionFields } from '../mixins/optionFields'

export default {
  name: 'header-user-info',
  mixins: [optionFields],
  data: () => ({
    user: {},
  }),
  computed: {
    addressTxt() {
      if (!this.user || !this.fields.country) return ''
      const user = this.user

      if (user.home && user.home.step >= 3) {
        return `${this.getFieldName(user.home.country, 'country')} - ${user.home.city}`
      }

      if (!user.search || !user.search.id || user.search.id.replace(/[0-]/g, '') === '') {
        return ''
      }

      const city_searches = user.search.city_searches
      if (!city_searches || city_searches.length === 0) return ''

      const countries = {}
      const cities = {}
      const groups = {}
      for (const value of city_searches) {
        if (!value.geoname) continue

        // Init new country
        const country_id = value.geoname.country_id
        if (!countries[country_id]) {
          countries[country_id] = true
          cities[country_id] = {}
          groups[country_id] = {}
        }

        // Add to city/group
        if (value.type === 3) {
          const key = `${value.geoname.admin_code_1}-${value.geoname.admin_code_2}-${value.geoname.admin_code_3}`
          if (groups[country_id][key] && groups[country_id][key].length < value.geoname.name.length) continue
          groups[country_id][key] = value.geoname.name
        } else if (value.type === 1) {
          cities[country_id][value.geoname.admin_name_3] = true
        } else {
          cities[country_id][value.geoname.name] = true
        }
      }

      let res = Object.keys(countries).map(country_id => {
        return this.getFieldName(country_id, 'country') + ' - ' + [].concat(Object.keys(cities[country_id]), Object.values(groups[country_id])).sort().join(', ') + ', '
      }).join('\n')

      res = res.replace(/,\s*$/, '')

      return res
    },
  },
  created() {
    eventBus.$on('userChanged', (data) => {
      this.user = data
    })
  },
}
</script>

<style lang="scss">
.public-profile {
  .prenom-profil {
    width: 30%;
    left: 50% !important;
  }
}
#main .public-profile h1.prenom-profil {
  padding-top: 10px !important;
}
.prenom-profil .personal-info > div {
  // white-space: nowrap;
}
</style>
